import { styled } from "styled-components";

const FullPageContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: auto;
  align-items: flex-start;
  justify-content: center;
  padding: 0 20px;
`;

export default FullPageContainer;
